import React, { useContext } from "react";
import { GlobalContext } from "store/globalContext";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Stack,
  IconButton,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export const Confirmation = () => {
  const { confirmationWithCallback, closeConfirmationWithCallback } =
    useContext(GlobalContext);
  const isGlobalContextBasedPresent = !!confirmationWithCallback?.title;

  if (!isGlobalContextBasedPresent) return;

  const isConditionalCallbackPresent =
    !!confirmationWithCallback?.conditionalCallbackFn;

  const {
    title = undefined,
    message = undefined,
    proceed = () => null,
    proceedWithoutConditionalCallback = () => null,
    abort = () => null,
    extraData = undefined,
    buttonLabels = [],
    buttonColors = [],
  } = {
    title: confirmationWithCallback?.title,
    message: confirmationWithCallback?.message,
    abort: () => closeConfirmationWithCallback(),
    proceed: () => {
      confirmationWithCallback?.conditionalCallbackFn &&
        confirmationWithCallback.conditionalCallbackFn();
      setTimeout(() => confirmationWithCallback?.callbackFn());
      closeConfirmationWithCallback();
    },
    proceedWithoutConditionalCallback: () => {
      setTimeout(() => confirmationWithCallback?.callbackFn());
      closeConfirmationWithCallback();
    },
    extraData: confirmationWithCallback?.extraData,
    buttonLabels: confirmationWithCallback?.buttonLabels,
    buttonColors: confirmationWithCallback?.buttonColors,
  };

  return (
    <Dialog
      open
      aria-labelledby="confirmation-title"
      aria-describedby="confirmation-description"
    >
      <Stack
        alignItems={"flex-end"}
        sx={{ margin: 0, position: "absolute", top: 0, right: 0 }}
      >
        <IconButton aria-label="close" onClick={abort}>
          <CloseIcon fontSize="large" />
        </IconButton>
      </Stack>
      {title && <DialogTitle id="confirmation-title">{title}</DialogTitle>}
      {message && (
        <DialogContent id="confirmation-description">
          {message}
          {extraData && (
            <Box>
              {Array.isArray(extraData) ? extraData.join(", ") : extraData}
            </Box>
          )}
        </DialogContent>
      )}
      <DialogActions>
        <Stack
          mt={2}
          mb={2}
          width={"100%"}
          direction={"row"}
          justifyContent={"center"}
          alignItems={"center"}
          gap={0.1}
        >
          <Button
            variant="outlined"
            // @ts-ignore
            color={buttonColors[0]}
            onClick={abort}
          >
            {buttonLabels[0] ?? "Cancel"}
          </Button>
          &nbsp;
          {isConditionalCallbackPresent ? (
            <>
              <Button
                variant="contained"
                // @ts-ignore
                color={buttonColors[1] ?? "warning"}
                onClick={proceedWithoutConditionalCallback}
              >
                {buttonLabels[1] ?? "Discard & Proceed"}
              </Button>
              &nbsp;
              <Button
                variant="contained"
                // @ts-ignore
                color={buttonColors[2] ?? "success"}
                onClick={proceed}
              >
                {buttonLabels[2] ?? "Save & Proceed"}
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="contained"
                // @ts-ignore
                color={buttonColors[1]}
                onClick={proceed}
              >
                {buttonLabels[1] ?? "Proceed"}
              </Button>
            </>
          )}
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
